module.exports = __webpack_public_path__ + "img/RegisterApp2.c2169b93.png";